import { OnInit, Input, Output, EventEmitter, Component } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';

@Component({
  selector: 'iw-button-download',
  template: '<button class="btn btn-danger btn-xs" (click)="onClick(\'eliminar\')" ' +
            '*ngIf="!disabledDelete">Eliminar ' +
            '<i class="fa fa-trash" aria-hidden="true"></i></button>' +
            '<button class="btn btn-success btn-xs" (click)="onClick(\'dowmload\')"> Descargar ' +
            '<i class="fa fa-download" aria-hidden="true"></i></button>',
  styles: [`
        .btn-xs {
          font: 400 10.3333px Arial !important;
        }
    `]
})
export class ButtonDownloadDeleteComponent implements ViewCell, OnInit {
  // contiene el valor de entrada
  renderValue: number;
  // entrada del valor del boton
  @Input() value: number;
  // entrada de la fila a la cual se le dio click
  @Input() rowData: any;
  // salida del evento del click
  @Output() save: EventEmitter<any> = new EventEmitter();
  // Define cuando se bloquea o desbloquea el boton de eliminar
  disabledDelete = false;

  ngOnInit() {
    this.renderValue = this.value;
    if (this.rowData['finish']) {
      this.disabledDelete = true;
    }
  }

  /**
   * Emite el evento retornando la data de la fila selecionada al dar click en el boton
   *
   * @memberof ButtonDownloadComponent
   */
  onClick(action?: string) {
    if ((action === 'eliminar' && !this.disabledDelete) || action !== 'eliminar') {
      const data = {
        value: this.rowData,
        action: action
      };
      this.save.emit(data);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/component-table/button-download-delete.component.ts